<template lang="pug">
#page_content.sponsor.page
	Banner(v-bind:item='item_banner', classes='half')
	.container.article
		.row.justify-content-center: .col-sm-10
			h3.title {{ $t('general_advice') }}
			.sponsor_logos
				img(src='~@/assets/images/sponsor/sponsor_1.png')
			h3.title {{ $t('general_organizer') }}
			.sponsor_logos
				img(src='~@/assets/images/sponsor/sponsor_2.png')
				img(src='~@/assets/images/sponsor/sponsor_11.png')

			//- h3.title {{ $t('general_main_co_organizer') }}

			h3.title {{ $t('general_co_organizer') }}
			.sponsor_logos
				img(src='~@/assets/images/sponsor/sponsor_8.png')
				img(src='~@/assets/images/sponsor/sponsor_3.png')
				img(src='~@/assets/images/sponsor/sponsor_4.png')
				img(src='~@/assets/images/sponsor/sponsor_5.png')
				img(src='~@/assets/images/sponsor/sponsor_6.png')
				img(src='~@/assets/images/sponsor/sponsor_9.png')
				img(src='~@/assets/images/sponsor/sponsor_23.png')
				img(src='~@/assets/images/sponsor/sponsor_24.png')
				img(src='~@/assets/images/sponsor/sponsor_10.png')
			h3.title {{ $t('general_special_thanks_to') }}
			.sponsor_logos
				img(src='~@/assets/images/sponsor/sponsor_canada.png')
				img(src='~@/assets/images/sponsor/sponsor_french.png')
				img(src='~@/assets/images/sponsor/sponsor_germany.png')
			h3.title {{ $t('general_sponsors') }}
			.sponsor_logos
				img(src='~@/assets/images/sponsor/sponsor_12.png')
			h3.title {{ $t('general_press') }}
			.sponsor_logos
				img(src='~@/assets/images/sponsor/sponsor_13.png')
				img(src='~@/assets/images/sponsor/sponsor_14.png')
				img(src='~@/assets/images/sponsor/sponsor_15.png')
				img(src='~@/assets/images/sponsor/sponsor_16.png')
				img(src='~@/assets/images/sponsor/sponsor_17.png')
				img(src='~@/assets/images/sponsor/sponsor_25.png')
</template>

<script>
import Banner from '@/components/Banner.vue';
export default {
	data() {
		return {
			item_banner: {
				media: 'assets/images/banner_1.jpg',
				title: this.$t('nav_about_sponsor'),
			},
		};
	},
	watch: {
		'$i18n.locale'() {
			this.item_banner.title = this.$t('nav_about_sponsor');
		},
	},
	components: {
		Banner,
	},
};
</script>

<style lang="stylus">
#page_content.sponsor
	text-align: left
	color: #fff
	line-height: 2
	margin-bottom: 30px
	.container.article
		background-color: #fff
		@media (max-width: $screen-sm-max)
			padding: 2rem 20px
		.title
			color: $color_dark
	.title_star
		.title
			margin-bottom: 0
	.title
		margin-bottom: 20px
	.sponsor_logos
		display: flex
		flex-wrap: wrap
		margin-bottom: 30px
		img
			width: auto
			height: 70px
			margin: 0 15px 0 0
</style>
